import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "UiApp" }
const _hoisted_2 = {
  key: 0,
  class: "UiApp__sidebar"
}
const _hoisted_3 = { class: "sticky top-0 p-4" }
const _hoisted_4 = { class: "UiApp__body" }
const _hoisted_5 = { class: "UiApp__header" }
const _hoisted_6 = { class: "UiApp__content" }
const _hoisted_7 = { class: "UiApp__footer" }

import "./UiApp.css";

import { computed, onMounted, onUnmounted, provide, reactive, ref } from "vue";

import {
  AppbarHeightKey,
  AppScrollKey,
  TabbarHeightKey,
} from "../../injections";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiApp',
  setup(__props) {

const appRef = ref<HTMLDivElement>();

const AppbarHeight = ref(0);
const TabbarHeight = ref(0);
const AppScroll = reactive({ x: 0, y: 0 });

const safeAreaStyles = computed(() => ({
  paddingBottom: TabbarHeight.value + "px",
}));

// Fix 100vh for iOS system
function setVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

// Set scroll positions for fixed iOS overscroll behavior
function setScroll(e: Event) {
  const app = e.currentTarget as HTMLElement;

  AppScroll.x = app.scrollLeft;
  AppScroll.y = app.scrollTop;
}

onMounted(() => {
  setVh();
  appRef.value?.addEventListener("scroll", setScroll);
});

onUnmounted(() => {
  appRef.value?.removeEventListener("scroll", setScroll);
});

window.addEventListener("resize", setVh);

provide(AppbarHeightKey, AppbarHeight);
provide(AppScrollKey, AppScroll);
provide(TabbarHeightKey, TabbarHeight);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "appRef",
    ref: appRef,
    class: "UiWrapper"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "UiApp__in",
        style: _normalizeStyle(_unref(safeAreaStyles))
      }, [
        (!_ctx.$breakpoints.xs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "sidebar")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "header")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "footer")
          ])
        ])
      ], 4)
    ])
  ], 512))
}
}

})